import React from 'react';
import { useNotifications } from '../../hooks/useNotifications';
import relativeTimeAgo from '../../utils/relativeTimeAgo';


function NotificationDropdownCard({ notification }) {
  
  const notificationDetails = useNotifications(notification.type);

  return (
    <div className='flex pb-4 w-full py-4'>
      <div className='flex justify-around items-center'>
        <span className='bg-primary-lightplus h-4 w-4 rounded-full'/>
      </div>
      <div className='w-full text-sm ml-4 whitespace-normal overflow-hidden'>
        <p className='text-gray-500 mb-1 '>
          {notificationDetails.body}
        </p>
        <span className='font-medium'>
          {relativeTimeAgo(notification.created_at)}
        </span>
      </div>
    </div>
  )
}

export default NotificationDropdownCard
